import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import style from '../css/Details.module.css';
import HeaderBarBack from '../components/HeaderBarBack';

const Details = () => {
	const { order_number } = useParams();
	const navigate = useNavigate();
	const [bookingData, setBookingData] = useState(null);
	const [agentData, setAgentData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	// Fetch Booking Details
	const fetchBookingDetails = async () => {
		setLoading(true);
		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/FetchBooking.php?order_number=${order_number}`
			);
			const result = await response.json();

			if (result.status) {
				setBookingData(result.data);
			} else {
				setError(result.msg);
			}
		} catch (err) {
			setError('Failed to fetch booking details');
		}
		setLoading(false);
	};

	// Fetch Agent Details
	const fetchAgentDetails = async (agentId) => {
		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${agentId}`
			);
			const result = await response.json();
			if (result.status) {
				setAgentData(result.data);
			} else {
				setAgentData(null);
			}
		} catch (err) {
			console.error('Error fetching agent details:', err);
			setAgentData(null);
		}
	};

	useEffect(() => {
		if (order_number) {
			fetchBookingDetails();
		}
	}, [order_number]);

	useEffect(() => {
		if (bookingData?.agent_id) {
			fetchAgentDetails(bookingData.agent_id);
		}
	}, [bookingData]);

	if (loading) {
		return <div className={style.loader}>Loading...</div>;
	}

	if (error) {
		return <div className={style.error}>{error}</div>;
	}

	return (
		<div className={style.container}>
			<HeaderBarBack title={'Bookings Details'} />
			<p className={style.date}>
				{new Date(bookingData.date).toLocaleDateString('en-GB')}
			</p>
			<p className={style.orderNumber}>Order: {bookingData.order_number}</p>

			<p
				className={`${style.status} ${
					bookingData.status === 'Completed' ? style.completed : style.pending
				}`}
			>
				{bookingData.status}
			</p>

			<div className={style.details}>
				<h3>Customer Details</h3>
				<p>Name: {bookingData.name}</p>
				<p>Phone: {bookingData.phone}</p>
				<p>Email: {bookingData.email}</p>
				<p>Service: {bookingData.service}</p>
				<p>Location: {bookingData.location}</p>
				<p>Message: {bookingData.message}</p>
			</div>

			{agentData && (
				<div className={style.agentDetails}>
					<h3>Agent Details</h3>
					<p>Name: {agentData.name}</p>
					<p>Phone: {agentData.phone}</p>
					<p>Agent ID: {agentData.agent_id}</p>
				</div>
			)}

			{bookingData.status === 'Completed' && (
				<button
					className={style.invoiceButton}
					onClick={() => navigate(`/invoices/${bookingData.order_number}`)}
				>
					View Invoice
				</button>
			)}
		</div>
	);
};

export default Details;
